export default {"src":"/_next/static/media/Docker Swarm.50f9cd5c.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};